/**
 * Cache-bust + optional gated-preview query for product preview URLs
 * (`modelImg` / `modelImgThumb`).
 */

export type PreviewImageAccess = {
  exp: number;
  sig: string;
};

/**
 * Cache-bust query for product preview URLs.
 * Server bumps `Product.imageVersion` when the PNG is replaced; append this to the CDN URL.
 */
export function previewImageCacheQuery(imageVersion?: number | null): string {
  return `?v=${imageVersion ?? 0}`;
}

/** Merge imageVersion, signed access, and optional share token into a preview CDN URL. */
export function buildProductPreviewUrl(
  baseUrl: string,
  opts?: {
    imageVersion?: number | null;
    access?: PreviewImageAccess | null;
    share?: string | null;
  }
): string {
  const params = new URLSearchParams();
  params.set('v', String(opts?.imageVersion ?? 0));
  if (opts?.access?.sig && opts.access.exp) {
    params.set('exp', String(opts.access.exp));
    params.set('sig', opts.access.sig);
  }
  if (opts?.share?.trim()) {
    params.set('share', opts.share.trim());
  }
  const join = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${join}${params.toString()}`;
}
